import { LogOut, User, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ScopeSwitcher } from '@/components/ScopeSwitcher';
import { EmergencyStopButton } from '@/components/EmergencyStop';
import { useAuth } from '@/auth/AuthContext';
import { useLocation, Link } from 'react-router-dom';
import TESTIDS from '@/constants/testIds';

const TITLE_BY_PATH = {
    '/admin/social': 'Dashboard',
    '/admin/social/brands': 'Brands',
    '/admin/social/accounts': 'Connected accounts',
    '/admin/social/composer': 'Composer',
    '/admin/social/drafts': 'Drafts',
    '/admin/social/calendar': 'Calendar',
    '/admin/social/comments': 'Comments inbox',
    '/admin/social/inbox': 'Direct messages',
    '/admin/social/analytics': 'Analytics',
    '/admin/social/automation': 'Automation & safety',
    '/admin/social/audit': 'Audit logs',
    '/admin/social/keys': 'API Keys',
    '/admin/social/settings': 'Settings',
};

export function TopBar() {
    const { user, logout } = useAuth();
    const { pathname } = useLocation();
    let title = TITLE_BY_PATH[pathname];
    if (!title) {
        // for nested routes like /admin/social/brands/:id
        const segments = pathname.split('/').filter(Boolean); // e.g. ['admin','social','brands','xyz']
        if (segments[0] === 'admin' && segments[1] === 'social') {
            const root = '/' + segments.slice(0, 3).join('/'); // /admin/social/<section>
            title = TITLE_BY_PATH[root] || 'Social Operator';
        } else {
            title = TITLE_BY_PATH['/' + segments[0]] || 'Social Operator';
        }
    }
    return (
        <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b border-[hsl(var(--hairline))] bg-[hsl(var(--background))/0.85] px-4 backdrop-blur">
            <Button
                asChild
                variant="ghost"
                size="sm"
                className="text-muted-foreground hover:text-foreground"
                data-testid="topbar-back-to-admin"
            >
                <Link to="/admin">
                    <ArrowLeft className="mr-1 h-3.5 w-3.5" />
                    Admin
                </Link>
            </Button>
            <div className="h-5 w-px bg-border" aria-hidden="true" />
            <div className="min-w-0 flex-1">
                <div className="text-[11px] font-mono uppercase tracking-wider text-muted-foreground">
                    private operator console
                </div>
                <div className="truncate text-base font-semibold tracking-tight">{title}</div>
            </div>
            <ScopeSwitcher />
            <EmergencyStopButton />
            <div className="ml-2 flex items-center gap-2 rounded-md border border-border bg-[hsl(var(--surface-2))] px-2 py-1">
                <User className="h-3.5 w-3.5 text-muted-foreground" />
                <span className="font-mono text-xs text-muted-foreground">
                    {user?.email || 'admin'}
                </span>
            </div>
            <Button
                variant="ghost"
                size="sm"
                onClick={() => { logout(); window.location.href = '/admin/login'; }}
                data-testid={TESTIDS.logoutButton}
                className="text-muted-foreground hover:text-foreground"
            >
                <LogOut className="mr-1 h-4 w-4" />
                Logout
            </Button>
        </header>
    );
}
